import React from 'react';
import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';

export const LandingPage = lazy(
  () =>
    import('./LandingPage.eager').then(mod => ({
      default: mod.LandingPage,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
